import { Link } from "react-router-dom";
export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
      <h1 className="font-display text-4xl text-gold mb-4">Set Aside for Later</h1>
      <p className="text-parchment/75 italic mb-8">No purchase made — your cabinet remains as you left it.</p>
      <Link to="/shop" className="btn-outline">Continue Browsing</Link>
    </div>
  );
}
